import React from 'react';
import InfoCard from '../../../components/dashboard';
import { UserApi } from '../../../apis';

function Dashboard() {
    const [data, setData] = React.useState([]);
    let dataTitle = [
        {
            title: 'Total Projects',
            icon: 'DashboardIcon',
            key: 'projects'
        },
        {
            title: 'Total Users',
            icon: 'DashboardIcon',
            key: 'users'
        },
        {
            title: 'Total Time',
            icon: 'DashboardIcon',
            key: 'time'

        },
        {
            title: 'Total Groups',
            icon: 'DashboardIcon',
            key: 'groups'

        },

    ]
    React.useEffect(() => {
        UserApi.getAdminDashboardData().then((res) => {

            // map the response data to the dataTitle array
            let newData = dataTitle.map((item) => {
                let newItem = { ...item };
                newItem.number = res.data.data[item.key];
                return newItem;
            });

            setData(newData);

        });
    }
        , []);

    return (
        <InfoCard data={data} />
    );
}

export default Dashboard;